import styled from "styled-components";
import { BackToTop } from "discover.medical.react-component-library";

export const BackToTopWrapper = styled(BackToTop)`
  height: auto;
  transform: scale(0);
  opacity: 0;
  transition:
    opacity 1s,
    transform 0s linear 1s,
    height 0s linear 1s;

  ${({ $isVisible }) =>
    $isVisible &&
    `opacity: 1;
    height: auto;
    transform: scale(0.625);
    transition: height 0s, transform 0s, opacity 1s;
  `};
`;
